export enum SocialConnectionEnum {
  FB = 'facebook',
  GOOGLE = 'google-oauth2',
  RESIDENT = 'Resident',
}
